import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { ref } from 'vue'
import { BaseStore } from '@/store/index'

export async function get<T>(config: AxiosRequestConfig): Promise<T> {
  const baseState = BaseStore();

  baseState.isLoading = true;

  config.url = path(config.url!);
  config.method = 'GET';

  const newHeaders: Record<string, string> = config.data instanceof FormData ? { "Content-Type" : "multipart/form-data" } : { "Content-Type" : "application/json" };
  config.headers = { ...config.headers, ...newHeaders };

  const startTime = Date.now();
  const response: AxiosResponse<T> = await axios(config);
  const duration = Date.now() - startTime

  if (duration <= 200)
    await new Promise<void>((resolve) => setTimeout(resolve, 200));

  baseState.isLoading = false

  return response.data;
}

export async function post<T>(config: AxiosRequestConfig): Promise<T> {
  const baseState = BaseStore();

  baseState.isLoading = true;

  config.url = path(config.url!);
  config.method = 'POST';

  const newHeaders: Record<string, string> = config.data instanceof FormData ? { "Content-Type" : "multipart/form-data" } : { "Content-Type" : "application/json" };
  config.headers = { ...config.headers, ...newHeaders };
  
  const startTime = Date.now();
  const response: AxiosResponse<T> = await axios(config);
  const duration = Date.now() - startTime

  if (duration <= 200)
    await new Promise<void>((resolve) => setTimeout(resolve, 200));

  baseState.isLoading = false

  return response.data;
}

const path = (url: string): string => {
  const rootUrl = ref<string>('');

  // if (process.env.NODE_ENV == 'production')
  //   rootUrl.value = '/cm';

  const path = ref<string>('');

  if (url.startsWith('/')) {
    path.value = rootUrl.value + url
  } else if (url.startsWith('http://') || url.startsWith('https://')) {
    path.value = url;
  } else {
    path.value = url;
  }

  return path.value;
}